module.exports = require("babel-runtime/core-js/object/get-own-property-descriptors");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/core-js/object/get-own-property-descriptors"
// module id = 117
// module chunks = 0 1